import { EntityUnionType } from "common/types/entities/EntityInterface"
import { UPDATE_ENTITY } from "publisher/store/page/pageActionTypes"


export const updateEntity = (entity: EntityUnionType) => {
  return {
    payload: entity,
    type: UPDATE_ENTITY,
  }
}

export const pageActions = {
  updateEntity,
}
